<template>
  <span> <i :class="icon" :style="{ 'font-size': iconSize }"></i> </span>
</template>

<script>
export default {
  props: { extension: { required: true, type: String }, size: { required: false, type: String, default: "md" } },
  computed: {
    icon() {
      const ext = this.extension.toLowerCase();
      let icon;
      if (ext == "jpg" || ext == "jpeg" || ext == "jpeg") {
        icon = "bx bxs-file-jpg text-success";
      } else if (ext == "png") {
        icon = "bx bxs-file-png text-success";
      } else if (ext == "gif") {
        icon = "bx bxs-file-gif text-success";
      } else if (ext == "docx" || ext == "dotx" || ext == "dot") {
        icon = "bx bxs-file-doc text-primary";
      } else if (ext == "pdf") {
        icon = "bx bxs-file-pdf text-warning";
      } else if (ext == "xls" || ext == "xlsx") {
        icon = "bx bxs-file-doc text-success";
      } else if (ext == "pptx" || (ext == "pptm") | (ext == "ppt")) {
        icon = "mdi mdi-file-document text-warning";
      } else if (ext == "txt") {
        icon = "bx bxs-file-txt text-dark";
      } else if (ext == "json") {
        icon = "bx bxs-file-json text-warning";
      } else if (ext == "zip" || ext == "rar" || ext == "tar") {
        icon = "bx bxs-file-plus text-secondary ";
      } else {
        icon = "mdi mdi-file-document text-dark";
      }
      return icon;
    },
    iconSize() {
      let size;
      if (this.size == "md") {
        size = "2rem";
      } else if (this.size == "sm") {
        size = "font-size:1rem";
      } else if (this.size == "lg") {
        size = "font-size:2.5rem";
      }
      return size;
    },
  },
};
</script>
<style scoped>
.status {
  font-weight: bold;
  padding: 5px 10px;
  background-color: rgb(233 233 233);
  border-radius: 7px;
  min-width: 100px;
}
</style>
